"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundSystem = void 0;
const nanoevents_1 = require("nanoevents");
const wnd = window;
const polyfillAudioContext = wnd.AudioContext || wnd.webkitAudioContext;
const audioContext = new polyfillAudioContext();
class SoundSystem {
    constructor() {
        this.context = audioContext;
        this.events = (0, nanoevents_1.createNanoEvents)();
        const volume = parseFloat(localStorage.getItem('volume') || '0.3');
        localStorage.setItem('volume', volume.toString());
        this.channels = [];
        this.preMuteVolume = 1;
        this.masterGain = this.context.createGain();
        this.masterGain.gain.value = volume;
        this.masterGain.connect(this.context.destination);
        for (let i = 0; i < 8; ++i) {
            this.channels.push({
                source: null,
                gain: this.context.createGain()
            });
            this.channels[i].gain.connect(this.masterGain);
        }
    }
    static getContext() {
        return audioContext;
    }
    play(sound, channel, volume) {
        this.stop(channel);
        const gain = this.channels[channel].gain;
        gain.gain.value = Math.max(0, Math.min(1, volume));
        const source = this.context.createBufferSource();
        source.buffer = sound.buffer;
        source.connect(gain);
        source.start(0);
        this.channels[channel].source = source;
    }
    stop(channel) {
        const source = this.channels[channel].source;
        if (source) {
            source.stop(0);
        }
    }
    getVolume() {
        return this.masterGain.gain.value;
    }
    setVolume(value) {
        const current = this.masterGain.gain.value;
        if (current > 0 && value === 0) {
            this.preMuteVolume = current;
        }
        this.masterGain.gain.value = value;
        localStorage.setItem('volume', value.toString());
        this.events.emit('volumeChange', value);
    }
    toggleMute() {
        if (this.getVolume() === 0) {
            this.setVolume(this.preMuteVolume);
        }
        else {
            this.setVolume(0);
        }
    }
}
exports.SoundSystem = SoundSystem;
